import { documentHasElements } from "modules/dom";
import "./global-career-people.scss";

documentHasElements(".js-global-career-people", () => {

    const careerPeople = {
        init: function () {
            careerPeople.addSmoothScroll();
        },
        addSmoothScroll: () => {
            const html = document.querySelector("html");
            
            if (html) {
                html.classList.add("html-scroll__smooth");
            }
        },
    };

    careerPeople.init();

});